// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__1YkNc","hiddenImage":"Image_hiddenImage__3nETs","annotating":"Image_annotating__2q0eN"};